import { CountryEntity } from 'api/types/entity';
import { useStableKeys } from 'hooks';
import { Stack } from 'libs/ui';
import { useFormContext } from 'modules/client/legal/forms/companyBankAccountsForm';

import { Header, Fields } from './components';

export interface FormContentProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  onRemoveBankAccount?: (index: number) => void;
}

export const FormContent = ({
  countriesLoading,
  countries,
  onRemoveBankAccount,
}: FormContentProps) => {
  const { values } = useFormContext();

  const bankAccountsKeys = useStableKeys(values.bankAccounts);

  return (
    <Stack spacing={24}>
      {values.bankAccounts.map((_, index) => (
        <Stack key={bankAccountsKeys[index]} spacing={12}>
          <Header index={index} onRemoveBankAccount={onRemoveBankAccount} />

          <Fields
            countries={countries}
            countriesLoading={countriesLoading}
            index={index}
          />
        </Stack>
      ))}
    </Stack>
  );
};
